import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore } from '../../helpers/api/apiCore';

// helpers
//using '../../helpers' here didn't work for some reason - Hammad
import { 
    repairReceAPI,
    UPD_repairReceAPI,
    repairSendAPI,
    UPD_repairSendAPI,
    repairReturnAPI,
    UPD_repairReturnAPI,
    repairHandoverAPI,
    UPD_repairHandoverAPI,
    
} from '../../helpers';

// actions
import { repairsuccess, repairerrors } from './actions';

// constants
import { RepairType } from './constants';

type repairData = {
    payload: {
        id: string;
        entrydate: string;
        customerid: string;
        name: string;
        phone: string;
        address: string;
        details: string;
        phonecode: string;
        voucherdetdata: [];
    };
    type: string;
};

type send_repairData = {
    payload: {id:string;entrydate:string;supplierid:string;details:string;voucherdetdata:[]};
    type: string;
};
type return_repairData = {
    payload: {id:string;entrydate:string;supplierid:string;paymethod:string,postentry:string;bankid:string,reference:string;amount:string;voucherdetdata:[]};
    type: string;
};
type handover_repairData = {
    payload: {id:string;entrydate:string;customerid:string;phone:string;name:string;address:string;paymethod:string,postentry:string;bankid:string,reference:string;amount:string;phonecode:string;voucherdetdata:[];sparepartdata:[]};
    type: string;
};

const api = new APICore();
function* add_receive({
    payload: { entrydate, customerid, details, name, phone, address, phonecode, voucherdetdata },
}: repairData): SagaIterator {
    try {
        const response = yield call(repairReceAPI, {
            entrydate,
            customerid,
            details,
            name,
            phone,
            address,
            phonecode,
            voucherdetdata,
        });
        const receive = response.data;
        yield put(repairsuccess(RepairType.REPAIR_RECE, receive));
    } catch (error: any) {
        yield put(repairerrors(RepairType.REPAIR_RECE, error));
    }
}
function* upd_receive({
    payload: { id, entrydate, customerid, details, name, phone, address, phonecode, voucherdetdata },
}: repairData): SagaIterator {
    try {
        const response = yield call(UPD_repairReceAPI, {
            id,
            entrydate,
            customerid,
            details,
            name,
            phone,
            address,
            phonecode,
            voucherdetdata,
        });
        const receive = response.data;
        yield put(repairsuccess(RepairType.UPD_REPAIR_RECE, receive));
    } catch (error: any) {
        yield put(repairerrors(RepairType.UPD_REPAIR_RECE, error));
    }
}
function* add_send({ payload: {entrydate,supplierid,details,voucherdetdata} }: send_repairData): SagaIterator {
    try {
        const response = yield call(repairSendAPI, {entrydate,supplierid,details,voucherdetdata});
        const receive = response.data;
        yield put(repairsuccess(RepairType.REPAIR_SEND, receive));
    } catch (error: any) {
        
        yield put(repairerrors(RepairType.REPAIR_SEND, error));
    }
}
function* upd_send({ payload: {id,entrydate,supplierid,details,voucherdetdata} }: send_repairData): SagaIterator {
    try {
        const response = yield call(UPD_repairSendAPI, {id,entrydate,supplierid,details,voucherdetdata});
        const receive = response.data;
        yield put(repairsuccess(RepairType.UPD_REPAIR_SEND, receive));
    } catch (error: any) {
        
        yield put(repairerrors(RepairType.UPD_REPAIR_SEND, error));
    }
}
function* return_add({ payload: {id,entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata} }: return_repairData): SagaIterator {
    try {
        const response = yield call(repairReturnAPI, {id,entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata});
        const receive = response.data;
        yield put(repairsuccess(RepairType.REPAIR_RETURN, receive));
    } catch (error: any) {
        
        yield put(repairerrors(RepairType.REPAIR_RETURN, error));
    }
}
function* upd_return({ payload: {id,entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata} }: return_repairData): SagaIterator {
    try {
        const response = yield call(UPD_repairReturnAPI, {id,entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata});
        const receive = response.data;
        yield put(repairsuccess(RepairType.UPD_REPAIR_RETURN, receive));
    } catch (error: any) {
        
        yield put(repairerrors(RepairType.UPD_REPAIR_RETURN, error));
    }
}
function* handover({ payload: {id,entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata} }: handover_repairData): SagaIterator {
    try {
        const response = yield call(repairHandoverAPI, {id,entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata});
        const receive = response.data;
        yield put(repairsuccess(RepairType.REPAIR_HANDOVER, receive));
    } catch (error: any) {
        
        yield put(repairerrors(RepairType.REPAIR_HANDOVER, error));
    }
}
function* upd_handover({ payload: {id,entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata} }: handover_repairData): SagaIterator {
    try {
        const response = yield call(UPD_repairHandoverAPI, {id,entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata});
        const receive = response.data;
        yield put(repairsuccess(RepairType.UPD_REPAIR_HANDOVER, receive));
    } catch (error: any) {
        
        yield put(repairerrors(RepairType.UPD_REPAIR_HANDOVER, error));
    }
}

export function* watchAdd(): any {
    yield takeEvery(RepairType.REPAIR_RECE, add_receive);
    yield takeEvery(RepairType.UPD_REPAIR_RECE, upd_receive);
    yield takeEvery(RepairType.REPAIR_SEND, add_send);
    yield takeEvery(RepairType.UPD_REPAIR_SEND,upd_send);
    yield takeEvery(RepairType.REPAIR_RETURN ,return_add);
    yield takeEvery(RepairType.UPD_REPAIR_RETURN  ,upd_return);
    yield takeEvery(RepairType.REPAIR_HANDOVER ,handover);
    yield takeEvery(RepairType.UPD_REPAIR_HANDOVER ,upd_handover);
}

function* repairSaga() {
    yield all([fork(watchAdd)]);
}

export default repairSaga;
